const searchArray = (search, record = [], cols = []) => {
	// Safety check: Kung ang record ay hindi array o undefined/null, mag-return ng empty array
	if (!Array.isArray(record)) {
		return [];
	}
	
	return record.filter((data) => {
		// Safety check: Kung ang data ay hindi object o null/undefined, i-skip
		if (!data || typeof data !== 'object') {
			return false;
		}
		
		let counter = 0;
		cols.forEach((col) => {
			if (Object.prototype.hasOwnProperty.call(data, col) && data[col] !== null && data[col] !== undefined)
				if (data[col].toString().toUpperCase().indexOf(search.toString().toUpperCase()) !== -1)
					counter += 1;
		});
		if (counter > 0) return true;

		return false;
	});
};

export default searchArray;